/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Customer, CustomerConsent } from "@/src/types/Entities/Customer";
import { apiPost } from "@/src/services/apiClient";

export function completeSmsRegistration(id: string, token: string, email: string): Promise<{ token: string; target: string }> {
  return apiPost("/registration_sms", { id, t: token, email }, { headers: new Headers({ Authorization: "" }) });
}

const isValidDateString = (s: unknown): s is string => typeof s === "string" && s.trim() !== "" && !Number.isNaN(Date.parse(s));

export function customerHasConsent(customer: Customer, consent: string): boolean {
  return (customer?.consents ?? []).some(
    (c) => c?.type === consent && isValidDateString(c?.approvalDate) && (c?.denialDate == null || String(c.denialDate).trim() === "")
  );
}

export function getCustomerConsent(customer: Customer, type: string): CustomerConsent | null {
  return (customer?.consents ?? []).find((c) => c?.type === type) ?? null;
}
